import {useEffect} from "react";

interface HeadProps {
    title: string;
}


export function Head(props: HeadProps) {

    useEffect(() => {
        document.title = props.title;
    }, [props.title]);

    return null;
}